module.exports="abcloader"


/*****************
 ** WEBPACK FOOTER
 ** ./loaders/module-description-file/~/testloader/lib/loader3.loader.js!./loaders/_resources/abc.txt
 ** module id = 2
 ** module chunks = 0
 **/